module.exports = __webpack_public_path__ + "img/screen7.24989f01.png";